import { Map } from 'immutable';
import { Reducer } from 'redux';
import { PermissionsState } from '../../../libs/IdeLink.Web.Common/src/app/AppState';
import { AuthenticationActions } from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Services/Authentication/Base/AuthenticationActions';

import { PermissionsActions } from './PermissionsActions';

const initialState = Map({ initialized: false }) as any;

export const PermissionsReducer: Reducer<PermissionsState, any> = (state = initialState, action) => {
    switch (action.type) {
        // case REHYDRATE:
        // Reset : return new Map({ ...initialState.toJS() });
        // return Map.isMap(state) ? state : new Map(state);
        //case PermissionsActions.LOG_OUT:
        case AuthenticationActions.LOG_OUT:
            return initialState;
        case PermissionsActions.SET_INITIALIZED:
            return state.set('initialized', action.initialized);
        default:
            state = Map.isMap(state) ? state : Map(state) as any;
            return state;
    }
};

